import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { DialogService } from '@cbre/components';
import { EntityType } from '@miq/domain';
import { PropertySetsDialogComponent } from '../property-sets-dialog/property-sets-dialog.component';
import { PropertySetMode, PropertySetView } from '../property-sets-dialog/property-sets-dialog';
import { User } from '@miq/user';

@Component({
  selector: 'miq-add-to-property-set-button, [addToPropertySetButton]',
  imports: [CommonModule, MatIconModule],
  template: `
    <mat-icon class="playlist_add" [svgIcon]="svgIcon"></mat-icon>
    <span class="mat-icon-label">{{ text }}</span>
  `,
  styleUrls: ['./add-to-property-set-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToPropertySetButtonComponent {
  @HostBinding('class.disabled') disabled = false;

  @Input() text = 'Add to Property Set';
  @Input() svgIcon = 'playlist_add';

  @Input() entity: EntityType = EntityType.Property;

  @Input() mode: PropertySetMode = PropertySetMode.Manage;
  @Input() source: string = null;
  @Input() userInfo: User;

  // convert ids and property types in setters
  private _ids: number[] = [];
  @Input() set ids(value: number[]) {
    this._ids = value;
    this._checkDisabled();
  }

  private _propertyTypes: string[] = [];
  @Input() set propertyTypes(value: string[]) {
    this._propertyTypes = value;
    this._checkDisabled();
  }

  private _markets: string[] = [];
  @Input() set markets(value: string[]) {
    this._markets = value;
  }

  private _levels: number[] = [];
  @Input() set levels(value: number[]) {
    this._levels = value;
  }

  @Output() propertySetDialogEvent = new EventEmitter<unknown>();

  constructor(private dialogService: DialogService) {}

  private _checkDisabled(): void {
    this.disabled =
      this.mode === PropertySetMode.Manage &&
      (this._ids?.length === 0 || (this.entity === EntityType.Property && this._propertyTypes?.length !== 1));
  }

  @HostListener('click', ['$event']) onClick(): void {
    if (this.disabled) return;

    const filters = { markets: [], property_types: [], permission_level: [] };
    if (this._propertyTypes?.length > 0) {
      filters.property_types = this._propertyTypes;
    }

    if (this._markets?.length > 0) {
      filters.markets = this._markets;
    }
    if (this._levels?.length > 0) {
      filters.permission_level = this._levels;
    }

    const data: Record<string, any> = {
      ids: this._ids,
      dialogMode: this.mode,
      entity: this.entity,
      source: this.source,
      filters,
      view: PropertySetView.List,
      userInfo: this.userInfo,
      externalUsageType: this._propertyTypes?.length === 1 ? this._propertyTypes[0] : '',
    };

    const options = {
      panelClass: ['table-modals', 'ps-manage-dialog'],
    };
    const previousScrollY = window.scrollY;
    window.scrollTo(0, 0);
    const dialogEvent = this.dialogService.openDialog(PropertySetsDialogComponent, data, options);
    if (dialogEvent) {
      dialogEvent.subscribe(event => {
        this.propertySetDialogEvent.emit(event);
        window.scrollTo(0, previousScrollY);
      });
    }
  }
}
